// src/lib/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions, httpsCallable } from 'firebase/functions';

const firebaseConfig = {
  apiKey:            "AIzaSyAJ8LCDzVpWg2vRSa7_GETIFr7NC_YxX6Y",
  authDomain:        "gather-d59be.firebaseapp.com",
  projectId:         "gather-d59be",
  storageBucket:     "gather-d59be.firebasestorage.app",
  messagingSenderId: "515351182048",
  appId:             "1:515351182048:web:cd4729badb5a67378bee85"
};

const app = initializeApp(firebaseConfig);

export const db        = getFirestore(app);
export const auth      = getAuth(app);
export const storage   = getStorage(app);
export const functions = getFunctions(app, 'europe-west1');
export const messaging = null;

// Callable Cloud Functions
export const callAIFormFill       = httpsCallable(functions, 'aiFormFill');
export const callExtractBulkEvents = httpsCallable(functions, 'extractBulkEvents');
export const callSetUserRole      = httpsCallable(functions, 'setUserRole');
export const callExportUserData  = httpsCallable(functions, 'exportUserData');
export const callDeleteAccount   = httpsCallable(functions, 'deleteUserAccount');
export const callCreatePayment   = httpsCallable(functions, 'createPaymentIntent');
export const callFollowOrganiser = httpsCallable(functions, 'followOrganiser');
export const callCreateSupportCheckoutSession = httpsCallable(functions, 'createSupportCheckoutSession');
export const callJoinWaitlist    = httpsCallable(functions, 'joinWaitlist');
export const callManualScan      = httpsCallable(functions, 'manualScanTown', { timeout: 280000 });
export const callGetReferralCount = httpsCallable(functions, 'getMyReferralCount');

export const saveFCMToken = async () => {};

export default app;
